import {
  history
} from './history.js';
import {
  param
} from './param.js';

export function changePage() {
  const nav = document.querySelectorAll('.nav__list li a');
  const allSection = document.querySelectorAll('section');

  for (let i = 0; i < nav.length; i++) {
    nav[i].addEventListener('click', function (e) {
      e.preventDefault();
      const target = nav[i].getAttribute('attr');
      var targetSection = document.getElementsByClassName(target);
      for (let j = 0; j < allSection.length; j++) {
        allSection[j].classList.remove('visible');
      }

      targetSection[0].classList.add('visible');
      document.body.setAttribute('content', target);

      if (target == 'homepage' || target == 'history') {
        history();
      }

      if (target == 'param') {
        param();
      }

      nav.forEach(e => {
        e.classList.remove(`nav__el--${e.getAttribute('attr')}Active`);
      });

      document.querySelector(`.nav__el--${target}`).classList.add(`nav__el--${target}Active`);

      window.scrollTo(0, -100);
      });
  }

  

  

}
